import React, { useCallback } from 'react';
import { Icon } from '@tt/ui';
import cx from 'classnames';
import { toast } from 'sonner';
import styles from './Toast.module.scss';
const typeIconMap = {
    info: 'info-filled',
    success: 'checkmark-filled',
    warning: 'warning-filled',
    error: 'error-2-filled',
};
const colorMap = {
    info: 'primary',
    success: 'success',
    warning: 'warning',
    error: 'error',
};
const Toast = ({ type, message, toastId }) => {
    const handleDismiss = useCallback(() => {
        toast.dismiss(toastId);
    }, [toastId]);
    return (React.createElement("div", { className: cx(styles.toast, styles[type]) },
        React.createElement("div", { className: styles.iconContainer },
            React.createElement(Icon, { name: typeIconMap[type], color: colorMap[type], className: styles.icon, size: "lg" })),
        React.createElement("div", { className: styles.messageContainer },
            React.createElement("span", { className: styles.message }, message)),
        React.createElement("button", { onClick: handleDismiss, className: styles.closeButton, "aria-label": "Close toast" },
            React.createElement(Icon, { name: "close", size: "md", className: "" }))));
};
export default Toast;
